var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpecefic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2c2c2d;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248.07,193.83c-27.72,0-50.21,22.5-50.21,50.21s22.5,50.21,50.21,50.21,50.21-22.49,50.21-50.21-22.5-50.21-50.21-50.21ZM248.07,274.17c-16.63,0-30.13-13.5-30.13-30.13s13.5-30.13,30.13-30.13,30.13,13.5,30.13,30.13-13.5,30.13-30.13,30.13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250,0C111.93,0,0,111.93,0,250s111.93,250,250,250,250-111.93,250-250S388.07,0,250,0ZM389.07,251.14s-8.07,8.09-20.27,20.28c-66.68,66.67-174.76,66.67-241.44,0-12.18-12.2-20.27-20.28-20.27-20.28-3.92-3.92-3.92-10.27,0-14.19,0,0,8.07-8.09,20.27-20.28,32.01-32.02,75.44-50,120.72-50s88.71,17.98,120.72,50c12.19,12.2,20.27,20.28,20.27,20.28,3.92,3.92,3.92,10.27,0,14.19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecefic);
export default __webpack_public_path__ + "static/media/Specefic.a33cb18913d6b83fcb4d8cf9268208c0.svg";
export { ForwardRef as ReactComponent };